import {
    FinanceLabField,
    FinanceLabFieldType,
} from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { SummaryRowConfig } from "../SummaryFinancials.types";

export const rowConfig: SummaryRowConfig[] = [
    {
        label: "Total Assets",
        codes: [
            AccountLabel.ASSETS,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 0,
    },
    {
        label: "Cash & Equivalents",
        codes: [
            AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
    {
        label: "Accounts Receivable",
        codes: [AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
    {
        label: "Inventory",
        codes: [AccountLabel.CURRENT_ASSETS_NET_INVENTORY],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
    {
        label: "Gross PP&E",
        codes: [AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
    {
        label: "Total Liabilities",
        codes: [
            AccountLabel.LIABILITIES,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 0,
    },
    {
        label: "Accounts Payable",
        codes: [AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
    {
        label: "Current Debt Balance",
        codes: [AccountLabel.CURRENT_LIABILITIES_DEBT],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 1,
    },
];
